import { get } from '@/pages/hmt/reservation/official-site/utils/fetch'
import { isPC } from '@/utils'
import thinkingdata from "thinkingdata-browser";
import { getCookie } from '@/utils/cookie'

// 创建 SDK 配置对象
const taConfig = {
  appId: '59aeb53930314ae3a6b7db065c29c061',
  serverUrl: 'https://ta-report.123u.com',
} 

const fromatQuery = () => {
  const query = decodeURIComponent(window.location.search.substring(1))
  const param: Record<string, string> = {}
  query.replace(/([^?&]+)=([^?&]+)/g, (s, v, k) => {
    param[v] = k
    return `${k}=${v}`
  })
  return param
}

export enum EventType {
  PcPageview = 'pcPageview',
  PcDownload = 'pcDownload',
  GooglePlayDownload = 'googlePlayDownload',
  AppStoreDownload = 'appStoreDownload',
  ApkDownload = 'apkDownload',
  MyCardPay = 'myCardPay',
}

const searchParams = new URLSearchParams(
  decodeURIComponent(window.location.search)
)

const getPathnameLastTwoPath = () => {
  const path = window.location.pathname
    .split('/')
    .slice(-2)
    .filter((item) => item)
    .join('/')
  return `/${path}`
}

/**
 * 用于从广告落地页跳转到官网，进行数据上报
 * 跳转过来 url 携带的关键字：{lpurl}?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{matchtype}&external_click_id={gclid}
 */
const useTA = <T = EventType>() => {
  const ta = thinkingdata

  const reportTrack = (
    event: T,
    btn?: string,
    extra?: Record<string, string>
  ) => {
    const btnInfo = btn ? { btnName: btn } : {}
    ta.track(event, {
      page: getPathnameLastTwoPath(),
      platform: 'gg',
      env: import.meta.env.MODE,
      is_pc: isPC() ? 'pc' : 'mobile',
      ...fromatQuery(),
      ...btnInfo,
      ...extra,
    })
  }

  const getGclid = () => {
    return (
      searchParams.get('external_click_id') ||
      getCookie('external_click_id') ||
      getCookie('gclid')
    )
  }

  /**
   * 用于判断是否是从广告跳转过来的
   */
  const isFromAd = () => !!searchParams.get('campaign')

  const downloadWindowsLauncher = async () => {
    try {
      const resp = await get(`/api/download/pc-launcher?gclid=${getGclid()}`)
      window.open((resp as any).data?.url)
      reportTrack(EventType.PcDownload as any)
    } catch (error) {
      console.error(error)
    }
  }

  return {
    initTa: () => thinkingdata.init(taConfig), // 用配置对象初始化 SDK
    isFromAd,
    reportTrack,
    downloadWindowsLauncher,
  }
}

export default useTA
